import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { useRef } from "react";
import InvoiceItemDisplay from "./InvoiceItemDisplay";

interface InvoiceItemsScrollProps {
  items: Array<{
    id: number;
    price: number;
    subscription?: number | null;
    service?: number | null;
    service_info?: { image?: string; name?: string } | null;
    subscription_info?: { image?: string; name?: string } | null;
  }>;
}

const InvoiceItemsScroll = ({ items }: InvoiceItemsScrollProps) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollBy = (offset: number) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: offset, behavior: "smooth" });
    }
  };

  if (items.length === 0) {
    return (
      <div className='bg-gray-50 rounded-lg p-6 text-center'>
        <p className='text-gray-500 text-lg'>لا توجد عناصر في هذه الفاتورة</p>
      </div>
    );
  }

  return (
    <div className='space-y-4'>
      <h3 className='text-lg font-bold text-right text-gray-800'>
        العناصر المطلوبة
      </h3>
      <div className='relative'>
        {items.length >= 3 && (
          <>
            <button
              disabled={items.length === 0}
              className={`${
                items.length === 0
                  ? "opacity-50 cursor-not-allowed"
                  : "absolute left-0 top-1/2 z-10 -translate-y-1/2 bg-white shadow p-2 rounded-full"
              }`}
              onClick={() => scrollBy(-300)}
              type='button'
            >
              <IoChevronBack className='text-xl text-gray-600' />
            </button>

            <button
              disabled={items.length === 0}
              className={`${
                items.length === 0
                  ? "opacity-50 cursor-not-allowed"
                  : "absolute right-0 top-1/2 z-10 -translate-y-1/2 bg-white shadow p-2 rounded-full"
              }`}
              onClick={() => scrollBy(300)}
              type='button'
            >
              <IoChevronForward className='text-xl text-gray-600' />
            </button>
          </>
        )}

        <div
          ref={scrollRef}
          className='flex gap-4 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-4 px-10 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100'
          style={{ direction: "rtl" }}
        >
          {items.map((item, index) => (
            <div
              key={item.id || index}
              className='snap-start flex-shrink-0 w-[80%] sm:w-[48%] md:w-[30%]'
            >
              <InvoiceItemDisplay item={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InvoiceItemsScroll;
